<template>
  <div>
    <vue-plotly
      :data="chartData"
      :options="chartOptions"
      :layout="layout"
    ></vue-plotly>
  </div>
</template>

<script>
import VuePlotly from "@statnett/vue-plotly";
export default {
  name: "OZGServiceFeatureNotImplementableReason",
  props: [],
  data() {
    return {
      aggregateOnImplementationLevel: null,
      chartData: {},
      chartOptions: {
        sort: false
      },
      layout: {
        showlegend: true,
        legend: { orientation: "h" }
      },

      gqlquery: this.query
    };
  },
  methods: {
    renderGraph: function(newVal) {
      console.log(newVal);

      var values = [
      ];
      var labels = [
      ];

      for (var x in newVal) {
        // Shows only the explicitly set index of "5", and ignores 0-4
          if(newVal[x].name !== "") {
              values.push(newVal[x].count);
              labels.push(newVal[x].name);
          }
      }

      var data = [
        {
          values: values,
          labels: labels,
          hovertemplate:
            "%{label}<br>Leistungen: <b>%{value} - %{percent} </b> <extra></extra>",

          type: "pie",
          sort: false
        }
      ];

      this.chartData = data;
    }
  },
  watch: {
    countAggregateNotImplementable: function(newVal) {
      this.renderGraph(newVal);
    }
  },
  components: { VuePlotly },

  apollo: {
    $client: "ozgClient",
    countAggregateNotImplementable: {
        query() {
        return require("../../graphql/countAggregateNotImplementable.gql");
      },
    }
  }
};
</script>

<style scoped>
.chart {
}
</style>
